import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import useColors from 'hooks/useColors';
import { IconWithGradient } from '../Icon';
const IconStatusPaused = ({ bgColor, color, width = 18, height = 18, ...props }) => {
    const colors = useColors();
    const id = useId();
    return (<IconWithGradient id={id} {...props} width={width} height={height} viewBox="0 0 16 16" defaultGradientKey="white">
      <Path d="M15.872 10.0713C15.493 13.1036 13.1046 15.492 10.0723 15.871C8.69677 16.043 7.30518 16.043 5.92965 15.871C2.89738 15.492 0.508966 13.1036 0.129932 10.0713C-0.0420087 8.69579 -0.0420086 7.3042 0.129932 5.92867C0.508967 2.8964 2.89738 0.50799 5.92965 0.128956C7.30518 -0.0429848 8.69677 -0.0429846 10.0723 0.128956C13.1046 0.507991 15.493 2.8964 15.872 5.92867C16.044 7.30421 16.044 8.69579 15.872 10.0713Z" fill={bgColor ?? colors.cards.onLight}/>
      <Path d="M6 10.5L6 5.5" strokeWidth="2" strokeLinecap="round" stroke={color ?? `url(#gradient_${id})`}/>
      <Path d="M10 10.5L10 5.5" strokeWidth="2" strokeLinecap="round" stroke={color ?? `url(#gradient_${id})`}/>
    </IconWithGradient>);
};
export default IconStatusPaused;
